<template>
  <el-dialog
    custom-class="mobile-dialog"
    width="1100px"
    :visible="modalShow"
    title="个人报名信息"
    label-width="100px"
    @close="handleClose"
    top="7vh"
    :before-close="handleClose"
  >
    <el-table
      :data="subjectList"
      tooltip-effect="dark"
      class="modal-table"
      border
      fit
      @selection-change="handleSelectionChange"
      ref="modalTable"
      :row-key="rowKey"
    >
      <el-table-column
        v-if="row.examUserStatus !== 'Registered'"
        type="selection"
        :selectable="selectable"
        align="center"
        :reserve-selection="false"
        highlight-current-row
      >
      </el-table-column>
      <el-table-column label="科目名称" align="center">
        <template slot-scope="scope">{{ scope.row.subjectName }}</template>
      </el-table-column>
      <el-table-column label="科目考试费用" align="center">
        <template slot-scope="scope">{{ scope.row.price }}元</template>
      </el-table-column>
      <el-table-column label="考试时间" align="center">
        <template slot-scope="scope">{{ scope.row.examTime | parseTime }}</template>
      </el-table-column>
      <el-table-column label="考试时长" align="center">
        <template slot-scope="scope">{{ scope.row.examDuration }}分钟</template>
      </el-table-column>
      <el-table-column label="考试场次" align="center" show-overflow-tooltip>
        <template slot-scope="scope">{{ scope.row.examSeq }}</template>
      </el-table-column>
    </el-table>
    <!-- 表单  -->
    <el-form
      ref="dataForm"
      label-position="right"
      label-width="100px"
      :model="form"
      :inline="true"
      class="form"
      status-icon
      width="100%"
    >
      <el-form-item
        v-for="(item, index) in form.formList"
        :key="'form' + index"
        :inline="true"
        :label="item.label"
        :fixed="item.fixed"
        :min-width="item.minWidth"
        :class="[item.type == 'divider' ? 'block' : 'form-item', item.valid ? 'valid' : '']"
      >
        <template>
          <!-- 一般内容 -->
          <span v-if="item.type === 'label'">{{ item.prop }}</span>
          <!-- input -->
          <el-input
            v-else-if="item.type === 'input'"
            v-model="item.prop"
            size="small"
            :placeholder="item.placeholder || ''"
            :disabled="item.disabled"
          />
          <!-- select -->
          <el-select
            v-else-if="item.type === 'select'"
            v-model="item.prop"
            size="small"
            :placeholder="item.placeholder || '请选择'"
          >
            <el-option
              v-for="(option, oIndex) in item.customOption"
              :label="option.label"
              :value="option.value"
              :key="oIndex"
            />
          </el-select>
          <!-- 图片 -->
          <el-image
            v-else-if="item.type === 'img'"
            lazy
            style="width: 190px; height: 170px"
            :src="resolveImg(item.prop)"
            :preview-src-list="[resolveImg(item.prop)]"
          >
          </el-image>
          <!-- 上传 -->
          <el-upload
            v-else-if="item.type === 'upload'"
            class="avatar-uploader"
            :action="`${baseUrl}/file/upload/image`"
            :show-file-list="false"
            :headers="headers"
            :on-success="e => handleAvatarSuccess(e, item.prop)"
          >
            <img v-if="item.prop.startsWith('http')" :src="resolveImg(item.prop)" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>

          <!-- 分割线 -->
          <el-divider v-else-if="item.type === 'divider' && item.prop !== ''" content-position="center" class="divider">
            {{ item.prop }}
          </el-divider>
          <el-divider v-else-if="item.type === 'divider' && item.prop == ''" content-position="center" class="null">
            {{ item.prop }}
          </el-divider>
          <!-- 其他待定义,暂时以普通文本的形式展示 -->
          <span v-else>{{ item.prop }}</span>
        </template>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="cancel"> 取消 </el-button>
      <el-button v-if="row.examUserStatus === 'NoRegistered'" size="small" type="primary" @click="register">
        确定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getSubjectByExamId, getStudentDetail } from '@/modules/register/api/register'
import { getToken } from '@/utils/auth'
import { parseTime } from '@/utils/time'
import { resolveImg } from '@/utils/imgFill'
import cityData from "@/mixins/cityData";
export default {
  name: 'Modal',
  props: {
    // 编辑行数据
    row: {
      type: Object,
      default: () => {}
    },
    // 弹窗是否显示
    modalShow: {
      type: Boolean,
      default: false
    },
    // 首次报名/后续再次报名
    isFirst: {
      type: String,
      default: 'false'
    }
  },
  mixins: [cityData],
  data() {
    return {
      //科目列表
      subjectList: [],
      // 个人信息列表
      stuDetail: [],
      // 选中的考试科目
      multipleSelection: [],
      // 表单数据
      form: {
        formList: []
      },

      imageUrl: '',
      uploadList: {},
      headers: {
        Authorization: getToken()
      }
    }
  },
  computed: {},
  created() {},
  mounted() {},
  filters: {
    parseTime(val) {
      return parseTime(val, '{y}-{m}-{d} {h}:{i}:{s}') || '--'
    }
  },
  methods: {
    resolveImg,
    rowKey(row) {
      return row.id
    },
    selectable() {
      if (this.row.optional > 0) {
        return true // 可选
      } else {
        return false // 不可选
      }
    },
    clearValid() {
      this.$refs.dataForm.clearValidate()
    },
    handleAvatarSuccess(res, id) {
      this.$set(this.uploadList, id, res.accessAddress)
      for (let item of this.form.formList) {
        if (item.prop == id) {
          item.prop = res.accessAddress
          break
        }
      }
    },
    // 确定报名
    async register() {
      // 如果不可选，table数据都提交
      if (!this.row.optional) {
        this.multipleSelection = this.subjectList.map(item => item.id)
      }
      if (!this.multipleSelection.length) {
        this.$message({
          message: '请勾选至少一门科目',
          type: 'warning'
        })
        return
      }
      for (let item of this.form.formList) {
        if (item.valid) {
          if (item.type === 'input' && !item.prop) {
            return this.$message({
              message: `${item.infoName}不能为空`,
              type: 'warning'
            })
            return
          } else if (item.type === 'upload' && !item.prop.startsWith('http')) {
            return this.$message({
              message: `${item.infoName}不能为空`,
              type: 'warning'
            })
            return
          }
        }
      }

      const res = await this.$confirm('是否确认报名', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '再想想',
        type: 'warning'
      }).catch(()=>{})
      if(!res) return

      this.handleClose()
      this.form.formList = this.form.formList.filter(item => item.infoKey)
      this.form.formList.push({examDetailIds: this.multipleSelection})
      // console.log('提交的数据', this.form.formList);

      this.$emit('register', this.form.formList)
    },
    // 取消
    cancel() {
      this.$emit('cancel')
    },
    handleClose() {
      this.$emit('close')
    },
    // 全选
    handleSelectionChange(val) {
      console.log(">>>>>>>>>>>val",val)
      this.multipleSelection = val.map(item => item.id)
    },
    // 设置详情
    setDetail(stuDetail) {
      if (stuDetail) {
        this.form.formList = []
        this.form.formList.push(
          {
            label: '姓名',
            minWidth: 200,
            prop: stuDetail.realName,
            type: 'input',
            fixed: true,
            onBlur: true,
            onFocus: true,
            disabled: true
          },
          {
            label: '性别',
            minWidth: 200,
            prop: stuDetail.gender.msg,
            type: 'input',
            fixed: true,
            onBlur: true,
            onFocus: true,
            disabled: true
          },
          {
            label: '民族',
            minWidth: 200,
            prop: stuDetail.nation,
            type: 'input',
            fixed: true,
            onBlur: true,
            onFocus: true,
            disabled: true
          },
          {
            label: '籍贯',
            minWidth: 200,
            prop: stuDetail.nativePlace,
            type: 'input',
            fixed: true,
            onBlur: true,
            onFocus: true,
            disabled: true
          },
          {
            label: '学校',
            minWidth: 200,
            prop: stuDetail.institutionName,
            type: 'input',
            fixed: true,
            onBlur: true,
            onFocus: true,
            disabled: true
          },
          {
            label: '专业',
            minWidth: 200,
            prop: stuDetail.majorName,
            type: 'input',
            fixed: true,
            onBlur: true,
            onFocus: true,
            disabled: true
          },
          {
            label: '层次',
            minWidth: 200,
            prop: stuDetail.eduSystem.msg,
            type: 'input',
            fixed: true,
            onBlur: true,
            onFocus: true,
            disabled: true
          },
          {
            label: '考生类型',
            minWidth: 200,
            prop: stuDetail.examineeType.msg,
            type: 'input',
            fixed: true,
            onBlur: true,
            onFocus: true,
            disabled: true
          },
          {
            label: '手机号',
            minWidth: 200,
            prop: stuDetail.phone,
            type: 'input',
            fixed: true,
            onBlur: true,
            onFocus: true,
            disabled: true
          },
/*          {
            label: '通讯地址',
            minWidth: 200,
            prop: stuDetail.address,
            type: 'input',
            fixed: true,
            onBlur: true,
            onFocus: true,
            disabled: true
          },*/
          {
            label: '身份证号',
            minWidth: 200,
            prop: stuDetail.identityNum,
            type: 'input',
            fixed: true,
            onBlur: true,
            onFocus: true,
            disabled: true
          },
          {
            type: 'divider',
            prop: '-'
          },
          {
            label: '证件照',
            minWidth: 200,
            prop: stuDetail.avatar,
            type: 'img'
          },
          {
            label: '身份证人像面',
            minWidth: 230,
            prop: stuDetail.userIdCardFront,
            type: 'img'
          },
          {
            label: '身份证国徽面',
            minWidth: 200,
            prop: stuDetail.userIdCardBack,
            type: 'img'
          }
        )
      }
    },

    // 查询考试扩展信息
    getExamExtends(id, detail) {
      this.$store
        .dispatch('getExamCustom', id)
        .then(res => {
          if (res) {
            const filterRes = res
              .filter(item => item.propertyValue == 'INPUT')
              .concat(res.filter(item => item.propertyValue == 'FILE'))
            if (filterRes.length) {
              this.form.formList.push({
                type: 'divider',
                prop: '请补充以下信息'
              })
            }
            for (let item of filterRes) {
              if (item.propertyValue === 'FILE') {
                this.form.formList.push({
                  id: item.id,
                  label: item.propertyName,
                  prop: item.id,
                  type: 'upload',
                  infoName: item.propertyName,
                  infoKey: item.propertyKey,
                  infoType: item.propertyValue,
                  valid: true //需要校验
                })
              } else if (item.propertyValue === 'INPUT') {
                this.form.formList.push({
                  prop: '',
                  label: item.propertyName,
                  type: 'input',
                  infoName: item.propertyName,
                  infoKey: item.propertyKey,
                  infoType: item.propertyValue,
                  disabled: false, //可编辑
                  placeholder: `请输入${item.propertyName}`,
                  valid: true //需要校验
                })
              }
            }
          }
          if (detail) {
            this.setExamExtends(detail)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 设置考试扩展信息
    setExamExtends(res) {
      if (res) {
        for (let item of res) {
          for (let i of this.form.formList) {
            if (item.infoKey === i.infoKey) {
              i.prop = item.infoValue
              i.id = item.id
            }
          }
        }
      }
    },
    setSelectedSubject(list) {
      if (this.row.optional > 0) {
        this.multipleSelection = list.map(item => item.examDetailId)
        for (let i of this.subjectList) {
          for (let j of list) {
            if (j.examDetailId === i.id) {
              this.$refs.modalTable.toggleRowSelection(i)
            }
          }
        }
      } else {
        this.multipleSelection = this.subjectList.map(item => item.id)
        this.$refs.modalTable.toggleAllSelection()
      }
    }
  },
  watch: {
    list(newValue) {
      this.form.formList = newValue
    },
    modalShow(newValue) {
      if (newValue) {
        console.log(">>>>>>>>this.isFirst",this.isFirst)
        if (this.isFirst == 'true') {
          // 查询考试对应的科目
          getSubjectByExamId(this.row.id).then(res => {
            this.subjectList = res
            if(this.row.examUserStatus === 'Registered'){
              this.subjectList = this.subjectList.filter(item=>item.isSignup===1)
            }
            // if (!this.row.optional) {
            //   this.$refs.modalTable.toggleAllSelection()
            // }
            this.$nextTick(function () {
              this.subjectList.forEach((v, i) => {
                // if (v.status == 'CheckOk') {
                console.log('v=', v)
                this.$refs.modalTable.toggleRowSelection(v, true)
                // }
              })
            })
          })
          // 查询考生信息
          this.$store
            .dispatch('getStudentInfo', JSON.parse(localStorage.getItem('userInfo')).userId)
            .then(res => {
              this.setDetail(res)
              this.getExamExtends(this.row.id)
            })
            .catch(err => {
              console.log(err)
            })
        } else {
          // 接口1：查询考试对应的科目
          // console.log('可选row', this.row)
          getSubjectByExamId(this.row.examId).then(res => {
            this.subjectList = res
            if(this.row.examUserStatus === 'Registered'){
              this.subjectList = this.subjectList.filter(item=>item.isSignup===1)
            }
          })
          // 考试详情
          getStudentDetail(this.row.id)
            .then(res => {
              this.setDetail(res.examUserBaseModel)

              // 回显选中的科目
              this.setSelectedSubject(res.examUserDetailModels)
              // 回显附加信息
              this.getExamExtends(this.row.examId, res.examUserExtendModels)
            })
            .catch(err => {
              console.log(err)
            })
        }
      }
    }
  }
}
</script>

<style lang="scss">
.marjor-box {
  width: 100%;
  text-align: left;
  padding: 20px 30px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 200px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 200px;
  height: 180px;
  display: block;
}

.form-item {
  width: 33%; //三列
  margin-right: 0 !important;
}

.form-item.valid .el-form-item__label:before {
  content: '*';
  color: #f56c6c;
  margin-right: 4px;
}

.block {
  display: block;
}

.divider {
  width: 960px;
  height: 1px;
}

.null {
  opacity: 0;
  height: 0px;
}

.form {
  text-align: left;
  margin-top: 20px;
}

.el-dialog__body {
  padding-top: 10px;
}

.modal-table {
  width: 870px;
  margin: 0 auto;
}
@media screen and (min-width: 320px) and (max-width: 768px) {
  .mobile-dialog {
    width: 90% !important;
  }
  .el-table__body-wrapper {
    overflow-x: auto;
  }
  .form {
    .el-form-item {
      width: 100%;
      display: flex;
      .el-form-item__content {
        flex: 1;
      }
    }
  }
}
</style>
